import { render, staticRenderFns } from "./middleNav.vue?vue&type=template&id=4bd5cb18&scoped=true&"
import script from "./middleNav.vue?vue&type=script&lang=js&"
export * from "./middleNav.vue?vue&type=script&lang=js&"
import style0 from "./middleNav.vue?vue&type=style&index=0&id=4bd5cb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5cb18",
  null
  
)

export default component.exports